module.exports = {
    title: "惠合科技_一元乐享数字营销方案_提升复购、抢占市场",
    description: "基于“一物一码”技术，通过让利式营销，点燃消费者购买欲望，提升商品复购，抢占消费者心智",
    keywords: "一物一码,防伪防窜,二维码红包,私域流量,一元乐享,扫码活动"
}